import Autolinker from 'autolinker'

const EMAIL_REGEX = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
const URL_REGEX = /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})$/gi
const TEL_REGEX = /^(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?$/g

const DEFAULT_OPTS = {
  // Open links in new window
  newWindow: true,
  // Don't remove "https://www." etc from link text
  stripPrefix: false,
  // Don't remove trailing slash
  stripTrailingSlash: false,
  urls: {
    // Avoid autolinking filenames
    tldMatches: false,
  },
}

export interface LinkMatch {
  type: 'email' | 'tel' | 'url'
  href: string
}

export function match(text: string): LinkMatch | null {
  if (text.match(EMAIL_REGEX)) {
    return { type: 'email', href: `mailto:${text}` }
  }
  const matches = text.match(TEL_REGEX)
  if (matches) {
    const num = matches[0].replace(/[^a-zA-z0-9\+]/g, '')
    return { type: 'tel', href: `tel:${num}` }
  }
  if (text.match(URL_REGEX)) {
    return { type: 'url', href: text }
  }
  return null
}

export function link(text: string, opts = {}): string {
  return Autolinker.link(text, Object.assign({}, DEFAULT_OPTS, opts))
}
